import { client } from "../../../api/client"
export const fetchUser = async (email) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
        return require('./_local/_userData.json')
    } else {
        const responseUser = await client.get("users/users/email/" + email)
        return responseUser.data
    }
};